import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GamesList } from "@/components/ui/GameList";
import { useAuthContext } from "@/context/useAuthContext";
import { Loading } from "@/layouts/components";
import { useGetUserGamesQuery } from "@/store/api";
export var PersonalGamesList = function (props) {
    var user = useAuthContext().user;
    var userGamesListGetState = useGetUserGamesQuery({
        id: user.id,
        timeframe: props.timeFrame,
    });
    return (_jsxs(_Fragment, { children: [userGamesListGetState.isSuccess && (_jsx(GamesList, { data: userGamesListGetState.data.items })), _jsx(Loading, { isActive: userGamesListGetState.isLoading, loadingKey: "gameList" })] }));
};
